<template>
  <h2 class="content-block">User Details</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <DxToolbar class="menubar">
    <DxItem
        :options="cancelButtonOptions"
        location="before"
        widget="dxButton"
      />
    <DxItem
        :options="saveButtonOptions"
        location="before"
        widget="dxButton"
      />
    <DxItem
      :options="deleteButtonOptions"
      location="before"
      widget="dxButton"
    />
  </DxToolbar>

  <div class="content-block dx-card responsive-paddings">
    <DxForm id="form" 
        :form-data="user" 
        :label-mode="outside" 
        :read-only="false" 
        :show-colon-after-label="true"
        :label-location="top" 
        :col-count="1" 
        :min-col-width="300" 
        :width="null"
        :items="['userId', 'userName', 'firstName', 'surname']">
      >
      <DxSimpleItem data-field="userId" :editor-options="{readOnly: true}" />
      <!-- <DxSimpleItem editor-type="dxTextBox" data-field="userName" :editor-options="{readOnly: !isNewRec()}"/> -->
      <DxSimpleItem editor-type="dxTextBox" data-field="userName" />
      <DxSimpleItem editor-type="dxTextBox" data-field="firstName" />
      <DxSimpleItem editor-type="dxTextBox" data-field="surname" />
      <DxSimpleItem editor-type="dxSelectBox" data-field="view" 
        :editor-options="{ items: ['Default','Operator'], searchEnabled: true}"/>

    </DxForm>
  </div>
  
  <div class="content-block dx-card responsive-paddings" id="pwreset">
    <DxTextBox class="tb" label="Enter New Password" mode="text" :show-clear-button="true" v-model:value="resetPassword1" :input-attr="inputAttr">
      <DxValidator name="password">
        <DxStringLengthRule min="6" />
      </DxValidator>
    </DxTextBox>
    <DxTextBox class="tb" label="Renter Password" mode="text" :show-clear-button="true" v-model:value="resetPassword2" :input-attr="inputAttr">
      <DxValidator name="password">
        <DxStringLengthRule min="6" />
      </DxValidator>
    </DxTextBox>
  </div>

  <div class="content-block dx-card responsive-paddings" v-if="!isNewRec()">
    <UserGroup ref="groups"></UserGroup>
  </div>

  <DxToast
    v-model:visible="toastVisible"
    v-model:message="toastMessage"
    v-model:type="toastType"
    :position="toastPosition"
  />
  </div>
</template>

<script>

import DxForm, { DxSimpleItem } from "devextreme-vue/form";
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import notify from 'devextreme/ui/notify';
import DxTextBox from "devextreme-vue/text-box";
import {
    DxValidator,
    DxStringLengthRule
} from 'devextreme-vue/validator';
import { DxToast } from 'devextreme-vue/toast';
import UserGroup from './user-group.vue';
import { confirm } from 'devextreme/ui/dialog';

export default {
  components: {
    DxForm, 
    DxSimpleItem, 
    DxToolbar,
    DxItem,
    DxTextBox,
    DxValidator,
    DxStringLengthRule,
    DxToast, 
    UserGroup
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      toastVisible: false,
      toastMessage: '',
      toastType: 'info',
      toastPosition: {
          at: "bottom",
          my: "top",
          of: "#pwreset"},
      resetPassword1: "",
      resetPassword2: "",
      cancelButtonOptions: {
        icon: 'revert',
        onClick: () => {
          this.$router.go(-1);
        },
      },
      inputAttr: {
        mode: "password",
        inputAttr: {
          autocomplete: "off" //"new-password"
        }
      },
      saveButtonOptions: {
        icon: 'save',
        onClick: () => {
          // if it's a new user then
            //check password
            //add user
          // else then 
            //if password is >""
              //check password
            //update the user
          if (this.user.userId==0) //new user
          {
            if (!this.validatePassword())
            {
              this.toastType = 'error';
              this.toastMessage = 'Password error.  Ensure passwords match and are >= 6 characters in length.';
              this.toastVisible = true;
            }
            else
            {
              this.$store.dispatch('users/addUser', this.user);
              this.$emit('recordUpdated');
            }
          }
          else
          {
            if (!this.validatePassword())
            {
              this.toastType = 'error';
              this.toastMessage = 'Password error.  Ensure passwords match and are >= 6 characters in length.';
              this.toastVisible = true;
            }
            else
            {
              console.log(this.user);
              this.$store.dispatch('users/updateUser', this.user);
              this.$refs.groups.saveGroupMembership();
              this.$emit('recordUpdated');
            }
          }
          // if (!this.validatePassword())
          // {
          //   this.toastType = 'error';
          //   this.toastMessage = 'Password error.  Ensure passwords match and are >= 6 characters in length.';
          //   this.toastVisible = true;
          // }
          // else
          // {
          //   if (this.user.userId==0)
          //   {
          //     this.$store.dispatch('users/addUser', this.user);
          //     this.$emit('recordUpdated');
          //   }
          //   else
          //   {
          //     this.$refs.groups.saveGroupMembership();
          //     // this.$store.dispatch('users/updateUser', this.user);
          //     // this.$emit('recordUpdated');
          //   }
          // }
        },
      },
      deleteButtonOptions: {
        icon: 'close',
        onClick: () => {
          let result = confirm("<b>Are you sure you want to delete this user?</b>" + 
            "<p>Name: " + this.user.userName,
            "Delete?");
          result.then((dialogResult) => {this.delete(dialogResult);});
        },
      },
    };
  },
  computed: {
    
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1); 
    },
    user() {
      return this.$store.getters["users/getUser"];
    },
  },
  methods: {
    async delete(confirmed){
      if (!confirmed)
      { 
        this.popNotification('Delete record cancelled.','warning');
        return; 
      }
      await this.$store.dispatch('users/deleteUser', {userId: this.user.userId});
      this.$emit('recordUpdated');
      this.$router.go(-1);
      this.popNotification("Record deleted. ", 'success');
    },
    isNewRec(){
      return (this.currentRecordId==0)
    },
    refreshData(){
      this.loadPageData();
    },
    saveGridInstance: function(e) {
      this.dataGridInstance = e.component;
    },
    validatePassword(){
      this.user.pwHash = "";
      if (this.isNewRec() && this.resetPassword1 === this.resetPassword2 && this.resetPassword1.length>=6 )
      {
        this.user.pwHash = this.resetPassword1;
        return true;
      }
      if (!this.isNewRec() && this.resetPassword1 === this.resetPassword2 && this.resetPassword1.length>=6 )
      {
        this.user.pwHash = this.resetPassword1;
        return true;
      }
      if (!this.isNewRec() && this.resetPassword1 === this.resetPassword2 && this.resetPassword1.length==0 )
      {
        //don't update the password, it's just an update to other properties
        return true;
      }
      return false;
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("users/loadUser", { id: this.currentRecordId });
        // var d = new Date();
        // var datestring =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + "T" + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        // console.log(datestring);

      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    popNotification(msg, type){
      //types ['error', 'info', 'success', 'warning']
      const position = 'center';
      const direction = 'down-stack';
      
      notify(
        {
          message: msg,
          type: type
        },
        { 
          position, 
          direction 
        }
      );
    },
  },
};
</script>

<style scoped>
.menubar{
  padding: 0 60px 0 60px ;
}
.tb{
  margin: 10px 0 30px 0px;
}
</style>
